import React, { useState, useEffect } from 'react'
import { Table, Icon, Panel, ButtonGroup, IconButton } from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import { maskIdCard } from '../../../utils/dataUtil'

export default function BlacklistedTable({
  schema,
  loading,
  isViewMode,
  page = 1,
  displayLength = 5,
  defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ],
  onReload = () => {},
  onSelect = () => {},
  // isViewMode,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table

  const [tableData, setTableData] = useState([])

  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }
  const fs = localStorage.getItem('fontSize')

  useEffect(() => {
    setTableData(schema.values)
  }, [schema.values])

  // console.log('schema', schema)

  const handleChangeLength = (dataKey) => {
    onReload(1, dataKey)
  }

  const handleChangePage = (dataKey) => {
    onReload(dataKey, displayLength)
  }

  return (
    <>
      <Table
        wordWrap
        minHeight={350}
        autoHeight
        loading={loading}
        headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 80}
        data={tableData || []}
        style={{ marginTop: '20px' }}
      >
        <Column width={100} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              // return index + 1
              return (page - 1) * displayLength + index + 1
            }}
          </Cell>
        </Column>

        <Column width={200}>
          <HeaderCell>เลขบัตรประชาชน /เลขนิติบุคคล</HeaderCell>
          {/* <Cell dataKey="idCardOrTaxNumber" /> */}
          <Cell>
            {(rowData) => {
              return <>{maskIdCard(rowData.idCardOrTaxNumber)}</>
            }}
          </Cell>
        </Column>

        <Column width={200}>
          <HeaderCell>ชื่อ-สกุล/ ชื่อนิติบุคคล</HeaderCell>
          <Cell dataKey="nameOrJuristic" />
        </Column>

        <Column width={160} align="center">
          <HeaderCell>ประเภทการทิ้งงาน</HeaderCell>
          <Cell dataKey="blacklistAbandonmentType" />
        </Column>

        <Column width={180} align="center">
          <HeaderCell>สถานะ</HeaderCell>
          <Cell dataKey="blacklistStatus" />
        </Column>

        <Column width={200} minWidth={200} flexGrow={1}>
          <HeaderCell>รายละเอียดการทิ้งงาน</HeaderCell>
          <Cell dataKey="note" />
        </Column>

        {!isViewMode && (
          <Column width={200} align="center" fixed="right">
            <HeaderCell>จัดการรายการ</HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <>
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-df"
                        size="sm"
                        icon={<Icon icon="eye" className="bt-gost-icon-none-radius" />}
                        onClick={(e) => {
                          onSelect(rowData, 'view')
                        }}
                      ></IconButton>
                      {/* {schema?.disabled && ( */}
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-edit"
                        size="sm"
                        icon={<Icon icon="edit" className="bt-gost-icon-none-radius-edit" />}
                        onClick={(e) => {
                          onSelect(rowData, 'edit')
                        }}
                      ></IconButton>
                      {/* )} */}
                      {/* {schema?.isEnableDelete && (
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-cancel"
                          size="sm"
                          icon={<Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />}
                          onClick={(e) => {
                            onDelete(rowData)
                          }}
                        ></IconButton>
                      )} */}
                    </ButtonGroup>
                  </>
                )
              }}
            </Cell>
          </Column>
        )}
      </Table>
      <TablePagination
        lengthMenu={defaultLengthMenu}
        activePage={page}
        renderLengthMenu={(lengthMenu) => {
          return (
            <>
              {lengthMenu}
              {`รายการ/หน้า`}
            </>
          )
        }}
        renderTotal={(total) => {
          return <>{` ทั้งหมด ${total} รายการ`}</>
        }}
        displayLength={displayLength || 5}
        total={schema.totalSize || 0}
        onChangePage={handleChangePage}
        onChangeLength={handleChangeLength}
      />
    </>
  )
}
